/**
 * Vuex mutations for the "popup" module.
 *
 * Synchronous state writers for modal visibility flags and modal payload
 * data. Async work (API calls) lives in operations.js, which commits these
 * mutations with the results.
 */
export default {
  setShowModal(state, status) {
    state.showModal = status;
  },
  setOrgShowModal(state, status) {
    state.showOrgModal = status;
  },
  setShowModalDraft(state, status) {
    state.showModalDraft = status;
  },
  setShowModalReply(state, status) {
    state.showModalReply = status;
  },
  setShowModalAboutUs(state, status) {
    state.showModalAboutUs = status;
  },
  /** Store `payload` in `modalOrgData` if it looks like an org (has `ownerId`), otherwise in `modalData`. */
  setModalData(state, payload) {
    if (payload?.ownerId) {
      state.modalOrgData = payload;
    } else {
      state.modalData = payload;
    }
  },
  setReplyPostData(state, data) {
    state.replyPostData = data;
  },
  setQuotePostData(state, data) {
    state.quotePostData = data;
  },
};
